export default __webpack_public_path__ + "static/media/SourceSans3-Regular.d5f259bc.ttf";